// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__37460","title":"ClientCherryInfo_title__3aP5-","itemText":"ClientCherryInfo_itemText__2J01d"};